import get from 'lodash/get';
import { arrayIt } from '@/utils';
import { notificationExists } from '@/notifications/store/mutations';

export default {
	fetch({ commit, rootGetters }, force) {
		return new Promise((resolve, reject) => {
			if (rootGetters.isFetching('notifications')) {
				return resolve();
			}

			if (!force && rootGetters.isFetched('notifications')) {
				return resolve();
			}

			commit('fetching', 'notifications', { root: true });
			commit('loading', 'notifications', { root: true });

			return this._vm.$api
				.get({ wpEndpoint: 'omapp/v1/notifications/' })
				.then(({ body, status }) => {
					commit('setEnabled', 206 !== parseInt(status, 10));
					commit('doneLoading', 'notifications', { root: true });
					commit('fetched', 'notifications', { root: true });
					commit('setNotifications', body);
					resolve();
				})
				.catch((error) => {
					commit('setError', error);
					commit('doneLoading', 'notifications', { root: true });
					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
	dismiss({ state, commit }, notifications) {
		return new Promise((resolve, reject) => {
			notifications = arrayIt(notifications);
			if (!state.enabled) {
				notifications.forEach((n) => {
					commit('remove', n);
				});
				return resolve();
			}

			const ids = notifications.map((n) => n.id);
			if (!ids.length) {
				return resolve();
			}
			return this._vm.$api
				.post({ wpEndpoint: 'omapp/v1/notifications/dismiss/' })
				.send(arrayIt(ids))
				.then(({ body }) => {
					commit('setNotifications', body);
					resolve();
				})
				.catch((error) => {
					commit('closeAlerts');
					error.explanation = '<strong>Something went wrong</strong>';
					commit('setError', error);
					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
	maybeCreate({ state, dispatch }, payload) {
		const { notifications } = state;

		if (notificationExists(notifications, payload)) {
			return false;
		}

		dispatch('create', payload);
	},
	create({ commit, state }, payload) {
		return new Promise((resolve, reject) => {
			if (!state.enabled) {
				return commit('add', payload);
			}
			return this._vm.$api
				.post({ wpEndpoint: 'omapp/v1/notifications/create/' })
				.send(arrayIt(payload))
				.then(({ body }) => {
					commit('setNotifications', body);
					resolve();
				})
				.catch((error) => {
					commit('closeAlerts');
					error.explanation = '<strong>Something went wrong</strong>';

					const notifications = get(error, 'response.body.notifications');
					if (notifications && notifications.length) {
						commit('setNotifications', notifications);
					}
					commit('setError', error);
					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
};
